import { render } from "./ResumeConstantes.vue?vue&type=template&id=3ba6a49c&scoped=true"
import script from "./ResumeConstantes.vue?vue&type=script&lang=js"
export * from "./ResumeConstantes.vue?vue&type=script&lang=js"

import "./ResumeConstantes.vue?vue&type=style&index=0&id=3ba6a49c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba6a49c"]])

export default __exports__